/* KS · Museumpagina (ks-mp) · 18 Oct 2026. Set switch + add to cart for the ks-mp-* sections.
   Add to cart follows the gift box builder: open the drawer on the tap, POST /cart/add.js with the drawer section,
   fire variant:add + cart:change so the theme re-renders, fall back to cart:refresh. The landing page is stamped
   by ks-order-attribution (first page of the session), so nothing extra is sent here. */
(function () {
  if (window.__ksMp) return;
  window.__ksMp = true;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* 5 / 3 pairs switch: shows the panels with the same index inside the same section */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mp-set-btn]');
    if (!btn) return;
    var scope = btn.closest('[data-mp-shop]');
    if (!scope) return;
    var i = btn.getAttribute('data-mp-set-btn');
    scope.querySelectorAll('[data-mp-set-btn]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    scope.querySelectorAll('[data-mp-set-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-mp-set-panel') !== i; });
  });

  function addToCart(form) {
    var input = form.querySelector('input[type="radio"]:checked');
    var btn = form.querySelector('[data-mp-add]');
    var label = btn && btn.querySelector('[data-mp-label]');
    var msg = form.querySelector('[data-mp-msg]');
    var T = { adding: form.getAttribute('data-adding') || 'Toevoegen…', added: form.getAttribute('data-added') || 'In je winkelmandje', error: form.getAttribute('data-error') || 'Dat lukte niet. Probeer het nog eens.', pick: form.getAttribute('data-pick') || 'Kies eerst je maat.' };
    if (!btn || form.__busy) return;
    if (!input) { if (msg) { msg.textContent = T.pick; msg.classList.add('is-error'); } return; }
    var orig = label ? label.textContent : '';
    form.__busy = true; btn.disabled = true; if (label) label.textContent = T.adding;
    if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }

    var drawer = document.querySelector('cart-drawer');
    var secEl = drawer && drawer.closest('.shopify-section');
    var sid = secEl ? secEl.id.replace('shopify-section-', '') : null;
    if (drawer && typeof drawer.show === 'function') { drawer.classList.add('ks-cart-adding'); if (!drawer.hasAttribute('open')) { try { drawer.show(); } catch (err) {} } }

    var done = function (ok) {
      form.__busy = false; btn.disabled = false;
      if (drawer) drawer.classList.remove('ks-cart-adding');
      if (label) { label.textContent = ok ? T.added : orig; if (ok) setTimeout(function () { label.textContent = orig; }, 2400); }
    };

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(input.value, 10), quantity: 1 }], sections: [sid, 'ks-cart-json'].filter(Boolean).join(',') })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (added) {
        var cart = null;
        try {
          var node = added.sections && added.sections['ks-cart-json'] && new DOMParser().parseFromString(added.sections['ks-cart-json'], 'text/html').querySelector('[data-ks-cart-json]');
          cart = node ? JSON.parse(node.textContent) : null;
        } catch (err) { cart = null; }
        return (cart && cart.items ? Promise.resolve(cart) : fetch(root() + 'cart.js').then(function (r) { return r.json(); })).then(function (c) {
          c.sections = added.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added.items || [added], cart: c } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: c } }));
          if (!drawer) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            if (!drawer) return;
            if (!drawer.hasAttribute('open')) { try { drawer.show(); } catch (err) {} }
            if (!(c.sections && c.sections[sid])) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }, 700);
          done(true);
        });
      })
      .catch(function (err) {
        done(false);
        if (msg) { msg.textContent = (err && typeof err.description === 'string' && err.description) || T.error; msg.classList.add('is-error'); }
        if (drawer && drawer.hasAttribute('open') && typeof drawer.hide === 'function') { try { drawer.hide(); } catch (e2) {} }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-mp-buy]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-mp-buy]');
    if (!form) return;
    var msg = form.querySelector('[data-mp-msg]');
    if (msg && msg.classList.contains('is-error')) { msg.textContent = ''; msg.classList.remove('is-error'); }
  });

  /* In-page links (hero buttons, "Lees eerst het verhaal", the story card, "Terug naar de sokken") scroll smoothly and stop
     just under the sticky header (20 Oct 2026). The merklap squares have their own handler in ks-mp-grid.js. */
  function stickyOffset() {
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:var(--sticky-area-height,0px)';
    document.body.appendChild(probe);
    var h = probe.offsetHeight; probe.remove();
    return h;
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href^="#"]');
    if (!a || !a.closest('.ks-mp') || a.hasAttribute('data-mp-jump')) return;
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    var el = id && document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = el.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (window.history && history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* Scroll edge (20 Oct 2026, after the William Morris page, but made from the collection's own knit file).
     Opt-in per chapter: data-vine-motif = the sign in the cartouche at the chapter title; data-vine-strip = a narrow strip
     cut from a knit file (RMO: the hieroglyph column of the Zonen van Horus sock). As you scroll, the strip is written
     down the margin, one column per chapter from its title to just above the next knitted band. */
  function vineInit() {
    var chs = [].slice.call(document.querySelectorAll('.ks-mp-ch[data-vine-motif]'));
    var src = ''; chs.forEach(function (c) { if (!src && c.getAttribute('data-vine-strip')) src = c.getAttribute('data-vine-strip'); });
    if (!chs.length || !src || document.querySelector('.ks-mp-vine')) return;
    document.documentElement.classList.add('ks-mp-has-vine');
    var vine = document.createElement('div'); vine.className = 'ks-mp-vine'; vine.setAttribute('aria-hidden', 'true');
    var cv = document.createElement('canvas'); vine.appendChild(cv); document.body.appendChild(vine);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function hex(h) { return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]; }
    var TEAL = hex('#0A666D'), TEAL_LIGHT = hex('#3FA3A8');
    // cartouche signs in stitches (a stitch is 1.5x wider than tall); digits index the colours, '.' is empty
    var SIGN = {
      jakhals: { c: ['#14191A', '#A14D1F', '#0A666D', '#F0E6CC'],
        m: ['............1.1..', '............1.1..', '............111..', '...........1111..', '...........111111', '..........111....', '...1111111111....', '..11111111111....', '.111111111111....', '1111111111111111.', '1222222222222222.', '1.33333333333332.', '..2222222222222..'] },
      lotus: { c: ['#30697D', '#E09970', '#74993C', '#A14D1F'],
        m: ['.......1.......', '...1...1...1...', '...1..121..1...', '1..12.121.21..1', '11.12.121.21.11', '.1112212122111.', '..11121212111..', '...111121111...', '....3333333....', '.....33333.....', '.......3.......', '.......3.......', '.......3.......'] },
      uil: { c: ['#17336F', '#5B8FD6', '#F6EFE2', '#D8342A', '#F6B23A'],
        m: ['..1......1.', '..11....11.', '..11111111.', '..12211221.', '..12511251.', '..12211221.', '..11114111.', '.1221141111', '12221211111', '12212221111', '12122221111', '.1222221111', '..1222211..', '...11111...', '...4...4...', '..44..44...'] },
      nijlpaard: { c: ['#00AC9F', '#14191A', '#F0E6CC', '#0A666D'],
        m: ['..........1.1..', '...11111..11111', '.11111111111121', '111111111111111', '111111111111111', '111111111122221', '11111111111111.', '.1111111111111.', '..11111111111..', '..111.11.111...', '..111.11.111...'] }
    };
    var strip = null, regionTop = 0, regionH = 0, maxShown = 0;
    var im = new Image();
    im.onload = function () {
      var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
      var x = c.getContext('2d'); x.drawImage(im, 0, 0);
      try {
        var d = x.getImageData(0, 0, c.width, c.height).data, empty = [];
        for (var y = 0; y < c.height; y++) { var e = true; for (var k = 2; k < c.width - 2 && e; k++) if (d[(y * c.width + k) * 4 + 3]) e = false; empty.push(e); }
        strip = { w: c.width, h: c.height, d: d, empty: empty }; draw();
      } catch (err) {}
    };
    im.src = src;
    function place() {
      var W = document.documentElement.clientWidth, x, w;
      if (W < 600) { x = 6; w = 30; }
      else if (W < 1000) { x = Math.max(6, (W - 600) / 2 - 52); w = 36; }
      else if (W < 1280) { x = 12; w = 54; }
      else { x = Math.max(8, (W - 1200) / 2 - 99); w = 81; }
      var r0 = chs[0].getBoundingClientRect(), r1 = chs[chs.length - 1].getBoundingClientRect();
      regionTop = r0.top + window.pageYOffset; regionH = Math.max(0, r1.bottom - r0.top);
      vine.style.left = Math.round(x) + 'px'; vine.style.width = w + 'px';
      vine.style.top = Math.round(regionTop) + 'px'; vine.style.height = Math.round(regionH) + 'px';
    }
    function draw() {
      if (!strip) return;
      place();
      var cssW = vine.clientWidth || 30, cssH = regionH; if (!cssH) return;
      var COLS = strip.w, sw = cssW / COLS, sh = sw / 1.5, rows = Math.ceil(cssH / sh);
      cv.width = COLS; cv.height = rows; cv.style.height = (rows * sh) + 'px';
      var ctx = cv.getContext('2d'), img = ctx.createImageData(COLS, rows), d = img.data, sd = strip.d, x, y;
      function put(x, y, c, a) { if (x < 0 || x >= COLS || y < 0 || y >= rows) return; var p = (y * COLS + x) * 4; d[p] = c[0]; d[p + 1] = c[1]; d[p + 2] = c[2]; d[p + 3] = a === undefined ? 255 : a; }
      var top = chs[0].getBoundingClientRect().top;
      // one column per chapter: it starts at the cartouche by the title and stops above the next knitted band, so the
      // bands always sit on top; the inscription carries on where the previous chapter's column stopped
      var offset = 0;
      chs.forEach(function (ch) {
        var t = ch.querySelector('.ks-mp-ch__title') || ch, r = t.getBoundingClientRect(), cr = ch.getBoundingClientRect(), S = SIGN[ch.getAttribute('data-vine-motif')];
        var h = S ? S.m.length + 6 : 0, my = Math.round((r.top - top + Math.min(40, r.height * .5)) / sh), t0 = my - Math.floor(h / 2);
        var start = Math.max(0, S ? t0 : my), end = Math.min(rows, Math.floor((cr.bottom - top) / sh)) - Math.round(32 / sh), yy, xx;
        if (end <= start + 40) return;
        while (end > start + 40 && !strip.empty[(offset + end - start) % strip.h]) end--;
        for (yy = start; yy < end; yy++) {
          var sy = (offset + yy - start) % strip.h;
          for (xx = 0; xx < COLS; xx++) { var q = (sy * COLS + xx) * 4; if (sd[q + 3]) put(xx, yy, [sd[q], sd[q + 1], sd[q + 2]], sd[q + 3]); }
        }
        for (yy = end; yy < end + 2; yy++) for (xx = 0; xx < COLS; xx++) put(xx, yy, TEAL);
        offset += end - start;
        if (!S) return;
        // the cartouche: an outline only, so the sign sits on the chapter's own background; tied off with a bar underneath
        var x0 = 3, x1 = COLS - 4, cols = S.c.map(hex), sw2 = S.m[0].length;
        for (yy = t0 - 3; yy < t0 + h + 4; yy++) for (xx = 2; xx < COLS - 2; xx++) if (yy >= start) put(xx, yy, [0, 0, 0], 0);
        for (yy = t0; yy < t0 + h; yy++) for (xx = x0; xx <= x1; xx++) {
          var firstRow = yy === t0, lastRow = yy === t0 + h - 1;
          if ((firstRow || lastRow) && (xx === x0 || xx === x1)) continue;
          if (firstRow || lastRow || xx === x0 || xx === x1 || ((yy === t0 + 1 || yy === t0 + h - 2) && (xx === x0 + 1 || xx === x1 - 1))) put(xx, yy, TEAL);
        }
        for (xx = x0; xx <= x1; xx++) put(xx, t0 + h + 1, TEAL);
        var sx = Math.floor(COLS / 2) - Math.floor(sw2 / 2);
        for (var j = 0; j < S.m.length; j++) for (var k = 0; k < sw2; k++) { var c = S.m[j].charAt(k); if (c !== '.') put(sx + k, t0 + 3 + j, cols[+c - 1]); }
      });
      // dark chapters: a lighter teal (rules, glyphs and cartouche) so the column stays readable
      chs.forEach(function (ch) {
        if (!ch.classList.contains('is-dark')) return;
        var r = ch.getBoundingClientRect(), y0 = Math.max(0, Math.floor((r.top - top) / sh)), y1 = Math.min(rows, Math.ceil((r.bottom - top) / sh));
        for (var yy = y0; yy < y1; yy++) for (var xx = 0; xx < COLS; xx++) { var p = (yy * COLS + xx) * 4; if (d[p + 3] && d[p] === TEAL[0] && d[p + 1] === TEAL[1] && d[p + 2] === TEAL[2]) { d[p] = TEAL_LIGHT[0]; d[p + 1] = TEAL_LIGHT[1]; d[p + 2] = TEAL_LIGHT[2]; } }
      });
      ctx.putImageData(img, 0, 0);
      grow();
    }
    function grow() {
      if (reduce) { vine.style.clipPath = 'none'; return; }
      var shown = Math.max(0, Math.min(regionH, window.innerHeight * .74 - (regionTop - window.pageYOffset)));
      if (shown > maxShown) maxShown = shown;
      vine.style.clipPath = 'inset(0 0 ' + Math.max(0, regionH - maxShown) + 'px 0)';
    }
    var raf = null;
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = null; grow(); }); }, { passive: true });
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (Math.abs(window.innerWidth - lastW) > 40) { lastW = window.innerWidth; draw(); } });
    window.addEventListener('load', draw);
    setTimeout(draw, 1200);
    if ('ResizeObserver' in window) {
      var H = 0, ro = new ResizeObserver(function () { var h = chs[chs.length - 1].getBoundingClientRect().bottom - chs[0].getBoundingClientRect().top; if (Math.abs(h - H) > 40) { H = h; draw(); } });
      chs.forEach(function (c) { ro.observe(c); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vineInit); else vineInit();
})();
